var map = {
	"./about.svg": "6719",
	"./account-book-tax.svg": "09a1",
	"./advantage-bg.svg": "bed9",
	"./arrow-left.svg": "f6db",
	"./banner-btn-l.svg": "13b1",
	"./banner-btn-r.svg": "bbf7",
	"./banner-r-main.svg": "55ea",
	"./banner-r-r.svg": "daf5",
	"./banner.svg": "c972",
	"./case-arrow-left.svg": "ffca",
	"./case-arrow-right.svg": "ee64",
	"./case-icon-1.svg": "6235",
	"./case-icon-2.svg": "a4bf",
	"./case-icon-3.svg": "3b50",
	"./case-icon-4.svg": "40a4",
	"./case-swiper-left.svg": "602e",
	"./case-swiper-right.svg": "1813",
	"./case-user-compony.svg": "a50a",
	"./case-user-divider.svg": "09c9",
	"./close.svg": "bb7c",
	"./current.svg": "7a15",
	"./customer-slide-left.svg": "8cab",
	"./customer-slide-right.svg": "e7f6",
	"./financial-and-taxation.svg": "2228",
	"./logo.svg": "a5f7",
	"./news.svg": "4ee0",
	"./option.svg": "bf7b",
	"./pk.svg": "4f8f",
	"./price.svg": "ee41",
	"./product-center.svg": "c27e",
	"./product-six-1.svg": "83fd",
	"./product-six-2.svg": "e667",
	"./product-six-3.svg": "55e1",
	"./product-six-4.svg": "5ff8",
	"./product-two-1.svg": "0816",
	"./product-two-10.svg": "c33b",
	"./product-two-2.svg": "200c",
	"./product-two-3.svg": "6c9d",
	"./product-two-4.svg": "4b5e",
	"./product-two-5.svg": "cdde",
	"./product-two-6.svg": "ce99",
	"./product-two-7.svg": "74f3",
	"./product-two-8.svg": "8ac8",
	"./product-two-9.svg": "3d0b",
	"./question.svg": "22e2",
	"./right-arrow.svg": "1dd0",
	"./right.svg": "b67a",
	"./service.svg": "a5df",
	"./side-concat.svg": "1a7e",
	"./side-erweima.svg": "ee29",
	"./side-return-top.svg": "59cb",
	"./side-wechat.svg": "f42f",
	"./step-arrow-down.svg": "344c",
	"./taxation.svg": "210f",
	"./toggle-close.svg": "56de",
	"./toggle.svg": "f13f",
	"./top-logo.svg": "330a",
	"./tradition.svg": "850b",
	"./upload-ticket.svg": "8a5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";